import alertConfigService from "../../api/alertConfiguration.service.js";
import moment from "moment";

export default {
  data() {
    return {
      isDetailsLoading: false,
      toggle_severity: "All",
      alertsList: [],
      alertsListCopy: [],
      isResolveLoading: false,
    };
  },
  created() {
    this.fetchActiveAlerts();
  },
  filters: {
    formatDates: function (value) {
      if (value) {
        const format = "MM/DD/YYYY";
        return moment(value).format(format);
      } else {
        let emptydata = "";
        return emptydata;
      }
    },
  },
  methods: {
    async fetchActiveAlerts() {
      this.isDetailsLoading = true;
      try {
        const response = await alertConfigService.fetchActiveAlerts(
          this.$route.params.assetId
        );
        if (response) {
          this.isDetailsLoading = false;
          this.alertsList = response.data;
          this.alertsListCopy = response.data;
        } else {
          this.isDetailsLoading = false;
        }
      } catch (error) {
        this.isDetailsLoading = false;
        console.error("Error fetching active alerts:", error);
      }
    },

    changeSeverity(severityLevel) {
      this.alertsList = [...this.alertsListCopy];
      if (["Critical", "Normal", "Low", "None"].includes(severityLevel)) {
        this.alertsList = this.alertsList.filter(
          (ele) => ele.severity === severityLevel
        );
      }
    },

    // formatDate(value) {
    //   if (value) {
    //     return format(new Date(value), "MM/dd/yyyy");
    //   }
    //   return "";
    // },

    async resolveAlert(alertId) {
      try {
        this.isResolveLoading = true;
        const response = await alertConfigService.resolveAlert(alertId);
        if (response.isSuccess) {
          this.isResolveLoading = false;
          this.fetchActiveAlerts();
          this.$toast.success("Alert resolved successfully");
        } else {
          this.$toast.error("Unable to resolve Alert");
        }
      } catch (error) {
        this.isResolveLoading = false;
        this.$toast.error("Unable to resolve Alert");
        console.error("Error resolving alert:", error);
      }
    },
  },
};
